/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs */

const en_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review and tweak the AI's captions for each photo.`)
};

const es_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa y ajusta las leyendas de IA para cada foto.`)
};

const fr_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révisez et ajustez les légendes générées par l'IA pour chaque photo.`)
};

const de_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfen und passen Sie die KI-Bildunterschriften für jedes Foto an.`)
};

const ja_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各写真のAIキャプションを確認して調整します。`)
};

const zh_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审阅并微调AI为每张照片生成的说明。`)
};

const ar_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`راجع وقم بتعديل تعليقات الذكاء الاصطناعي لكل صورة.`)
};

const id_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau dan sesuaikan keterangan AI untuk setiap foto.`)
};

const it_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi e perfeziona le didascalie generate dall'IA per ogni foto.`)
};

const ru_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте и настройте подписи ИИ для каждой фотографии.`)
};

const pt_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reveja e ajuste as legendas da IA para cada foto.`)
};

const ko_review_and_tweak_the_ais_captions_for_each_photo = /** @type {(inputs: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 사진에 대한 AI의 캡션을 검토하고 조정하세요.`)
};

/**
* | output |
* | --- |
* | "Review and tweak the AI's captions for each photo." |
*
* @param {Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const review_and_tweak_the_ais_captions_for_each_photo = /** @type {((inputs?: Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_And_Tweak_The_Ais_Captions_For_Each_PhotoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "es") return es_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "fr") return fr_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "de") return de_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "ja") return ja_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "zh") return zh_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "ar") return ar_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "id") return id_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "it") return it_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "ru") return ru_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	if (locale === "pt") return pt_review_and_tweak_the_ais_captions_for_each_photo(inputs)
	return ko_review_and_tweak_the_ais_captions_for_each_photo(inputs)
});